module.exports = __webpack_public_path__ + "assets/settings.png?05326bc9890bc6eccbf219e80a2da609";